import { useState } from 'react';
import { Bell, Calendar, CheckCircle, ChevronDown, ChevronUp, X, CalendarCheck, BellDot, CircleAlert, ArrowRightLeft } from 'lucide-react';
import programSchedule from "../assets/files/IUMRS_ICAM_2025_Program_Schedule.pdf"

export default function NotificationDropdown() {
  const [isOpen, setIsOpen] = useState(false);



  const notifications = [
    {
      id: 2,
      icon: BellDot,
      title: "Gallary page now active",
      message: (
                <>
                  Please visit our gallery page to relive moments from the past conference
                </>
              ),
      color: "#16a34a",
      bgColor: "#f0fdf4"
    },
    {
      id: 1,
      icon: CheckCircle,
      title: "Speaker pages are now active",
      message: "The Plenary, Keynote and Invited speaker pages are now active. Please visit either for more information about our invited speakers.",
      color: "#16a34a",
      bgColor: "#f0fdf4"
    },
    {
      id: 2,
      icon: BellDot,
      title: "Presentation Schedule Available",
      message: (
                <>
                  The LOC has made available a preview of the presentation schedule for the conference. The final, complete program will be uploaded to this site soon.
                  {" "}
                  <a href='javacript:void(0)' onClick={() => window.open(programSchedule)} style={{ color: "#2563eb", border: "none", backgroundColor: "white"}}>
                    View Schedule
                  </a>
                  
                </>
              ),
      color: "#16a34a",
      bgColor: "#f0fdf4"
    },
    {
      id: 3,
      icon: ArrowRightLeft,
      title: "Venue Change for IUMRS-ICAM 2025 Conference",
      message: (
                <>
                  The venue for this year's conference has been moved from the Cedi Conference Center to the ISSER Conference Hall which remains situated on the University of Ghana Campus.
                  Click <a href="/iumrs-icam25/conference-venue" style={{ color: "#2563eb" }}>here</a> for more information.
                </>
      ),
      color: "#eb2525ff",
      bgColor: "#f0fdf4"
    },
    {
      id: 4,
      icon: CircleAlert,
      title: "Final Extension for Abstract Submission",
      message: "The deadline for abstract submission has been extended again till 31st October 2025.",
      color: "#eb2525ff",
      bgColor: "#ffefefff"
    },
    {
      id: 5,
      icon: BellDot,
      title: "Winter School Announcement",
      message: (
                <>
                  Updated notice on the Winter School lecture on Sustainable and Renewable Energy.
                  Click <a href='/iumrs-icam25/workshop/winter-school' style={{color : "#2563eb"}}>here</a> for more details.
                </>
      ),
      color: "#f17917ff",
      bgColor: "#eff6ff"
    },
    {
      id: 6,
      icon: CalendarCheck,
      title: "Conference Attendance Commitment",
      message: "Deadline to commit to conference attendance by payment or official notice to the LOC is set to 15th November 2025.",
      color: "#9333ea",
      bgColor: "#faf5ff"
    },
    {
      id: 7,
      icon: ArrowRightLeft,
      title: "Updates on Plenary Speakers",
      message: "Prof. Suprakas Sinha replaces Prof. Nicholas Kotov. New plenary Speaker to be confirmed soon. Profiles of the plenary speakers will be published soon.",
      color: "#193fa0ff",
      bgColor: "#f0fdf4"
    },
    {
      id: 8,
      icon: CheckCircle,
      title: "Acceptance Letters",
      message: "Acceptance letters are still being sent out. Please check your email regularly.",
      color: "#16a34a",
      bgColor: "#f0fdf4"
    }
  ];

  const styles = {
    container: {
      position: 'fixed',
      top: '5rem',
      right: '1rem',
      zIndex: 999,
      width: '24rem',
      maxWidth: 'calc(100vw - 2rem)'
    },
    button: {
      marginLeft: 'auto',
      display: 'flex',
      alignItems: 'center',
      gap: '0.5rem',
      background: 'linear-gradient(to right, #ffd06aff, #CA9D3B)',
      color: 'white',
      padding: '0.75rem 1rem',
      borderRadius: '0.5rem',
      border: 'none',
      boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      fontWeight: 600,
      fontSize: '1rem',
      animation: "shake 1s"
    },
    badge: {
      background: 'white',
      color: '#082D4A',
      borderRadius: '9999px',
      width: '1.5rem',
      height: '1.5rem',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '0.75rem',
      fontWeight: 700
    },
    dropdown: {
      position: 'absolute',
      right: 0,
      marginTop: '0.5rem',
      width: '100%',
      background: 'white',
      borderRadius: '0.75rem',
      boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
      border: '1px solid #e5e7eb',
      overflow: 'hidden',
      animation: 'slideDown 0.3s ease-out'
    },
    header: {
      background: 'linear-gradient(to right, #ffd06aff, #CA9D3B)',
      color: 'white',
      padding: '0.75rem 1rem',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    },
    headerContent: {
      display: 'flex',
      alignItems: 'center',
      gap: '0.5rem'
    },
    headerTitle: {
      fontWeight: 700,
      fontSize: '1.125rem',
      margin: 0
    },
    closeButton: {
      background: 'transparent',
      border: 'none',
      borderRadius: '9999px',
      padding: '0.25rem',
      cursor: 'pointer',
      color: 'white',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    notificationsList: {
      maxHeight: '24rem',
      overflowY: 'auto'
    },
    notificationItem: {
      padding: '1rem',
      transition: 'background-color 0.2s'
    },
    notificationContent: {
      display: 'flex',
      gap: '0.75rem'
    },
    iconWrapper: {
      borderRadius: '9999px',
      padding: '0.5rem',
      height: 'fit-content',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    textContent: {
      flex: 1
    },
    notificationTitle: {
      fontWeight: 600,
      color: '#111827',
      margin: '0 0 0.25rem 0',
      fontSize: '1rem'
    },
    notificationMessage: {
      fontSize: '0.875rem',
      color: '#4b5563',
      lineHeight: 1.5,
      margin: 0
    },
    footer: {
      backgroundColor: '#f9fafb',
      padding: '0.75rem 1rem',
      textAlign: 'center'
    },
    footerText: {
      fontSize: '0.75rem',
      color: '#6b7280',
      margin: 0
    }
  };

  return (
    <>
      <style>{`
        @keyframes slideDown {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes shake {
              0% { transform: translate(1px, 1px) rotate(0deg); }
              10% { transform: translate(-1px, -2px) rotate(-1deg); }
              20% { transform: translate(-3px, 0px) rotate(1deg); }
              30% { transform: translate(3px, 2px) rotate(0deg); }
              40% { transform: translate(1px, -1px) rotate(1deg); }
              50% { transform: translate(-1px, 2px) rotate(-1deg); }
              60% { transform: translate(-3px, 1px) rotate(0deg); }
              70% { transform: translate(3px, 1px) rotate(-1deg); }
              80% { transform: translate(-1px, -1px) rotate(1deg); }
              90% { transform: translate(1px, 2px) rotate(0deg); }
              100% { transform: translate(1px, -2px) rotate(-1deg); }

        }
        .notification-button:hover {
          box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
          transform: scale(1.05);
        }
        .close-button:hover {
          background-color: rgba(255, 255, 255, 0.2);
        }
        .notification-item:hover {
          background-color: #f9fafb;
        }
        .notification-item:not(:last-child) {
          border-bottom: 1px solid #f3f4f6;
        }
      `}</style>
      
      <div style={styles.container}>
        <div style={{ position: 'relative' }}>
          <button
            className="notification-button"
            style={styles.button}
            onClick={() => setIsOpen(!isOpen)}
          >
            <Bell size={20} />
            {/**<span>Important Updates</span>**/}
            <span style={styles.badge}>{notifications.length}</span>
            {isOpen ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
          </button>

          {isOpen && (
            <div style={styles.dropdown}>
              <div style={styles.header}>
                <div style={styles.headerContent}>
                  <Bell size={20} />
                  <h3 style={styles.headerTitle}>Announcements </h3>
                </div>
                <button
                  className="close-button"
                  style={styles.closeButton}
                  onClick={() => setIsOpen(false)}
                  aria-label="Close notifications"
                >
                  <X size={20} />
                </button>
              </div>

              <div style={styles.notificationsList}>
                {notifications.map((notif) => {
                  const Icon = notif.icon;
                  return (
                    <div
                      key={notif.id}
                      className="notification-item"
                      style={styles.notificationItem}
                    >
                      <div style={styles.notificationContent}>
                        <div style={{
                          ...styles.iconWrapper,
                          backgroundColor: notif.bgColor,
                          color: notif.color
                        }}>
                          <Icon size={20} />
                        </div>
                        <div style={styles.textContent}>
                          <h4 style={styles.notificationTitle}>{notif.title}</h4>
                          <p style={styles.notificationMessage}>{notif.message}</p>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>

              <div style={styles.footer}>
                <p style={styles.footerText}>
                  Stay updated with the latest conference information
                  <br />Last updated: 09/04/2026
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}